module.exports = __webpack_public_path__ + "img/85.d4be21dc.jpg";